import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { useContent } from "@/lib/content";
import { FadeUp, Eyebrow } from "@/components/Motion";
import EnquiryForm from "@/components/EnquiryForm";

export default function Contact() {
  const content = useContent();
  if (!content) return <div className="min-h-screen bg-ivory" />;
  const c = content.contact;
  const services = content.services || [];

  return (
    <main className="pt-[72px]">
      <section className="py-14 sm:py-20" data-testid="contact-page">
        <div className="wrap">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
            {/* left: info */}
            <div className="lg:col-span-5">
              <Eyebrow className="mb-6">Contact</Eyebrow>
              <FadeUp delay={0.05}>
                <h1 className="font-serif text-4xl leading-[1.05] text-charcoal sm:text-5xl lg:text-6xl">
                  Let's talk about your project.
                </h1>
              </FadeUp>
              <FadeUp delay={0.12}>
                <p className="mt-6 max-w-md leading-relaxed text-charcoal/65">{c.form_intro}</p>
              </FadeUp>

              <FadeUp delay={0.18}>
                <div className="mt-10 space-y-4">
                  <a href={`tel:${c.phone.replace(/\s/g, "")}`} data-testid="contact-phone-link" className="group flex items-center gap-4 rounded-lg border border-charcoal/10 bg-paper p-5 transition-all duration-300 hover:border-gold/60 hover:shadow-lg hover:shadow-charcoal/5">
                    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-charcoal text-ivory transition-colors group-hover:bg-gold group-hover:text-charcoal">
                      <Phone size={17} />
                    </span>
                    <span>
                      <span className="block font-mono text-[10px] uppercase tracking-[0.2em] text-charcoal/45">Phone Lucas</span>
                      <span className="mt-0.5 block text-lg font-semibold text-charcoal">{c.phone}</span>
                    </span>
                  </a>
                  <a href={`mailto:${c.email}`} data-testid="contact-email-link" className="group flex items-center gap-4 rounded-lg border border-charcoal/10 bg-paper p-5 transition-all duration-300 hover:border-gold/60 hover:shadow-lg hover:shadow-charcoal/5">
                    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-charcoal text-ivory transition-colors group-hover:bg-gold group-hover:text-charcoal">
                      <Mail size={17} />
                    </span>
                    <span>
                      <span className="block font-mono text-[10px] uppercase tracking-[0.2em] text-charcoal/45">Email</span>
                      <span className="mt-0.5 block break-all text-sm font-semibold text-charcoal">{c.email}</span>
                    </span>
                  </a>
                </div>
              </FadeUp>

              <FadeUp delay={0.24}>
                <div className="mt-8 rounded-lg border border-charcoal/10 bg-stone/50 p-6">
                  <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-charcoal/50">
                    <MapPin size={12} /> Service area
                  </p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {(content.about?.areas || []).map((a) => (
                      <span key={a} className="rounded-full border border-charcoal/15 bg-paper px-3.5 py-1.5 text-xs text-charcoal/70">{a}</span>
                    ))}
                  </div>
                  <p className="mt-5 flex items-start gap-2 text-sm leading-relaxed text-charcoal/60">
                    <Clock size={14} className="mt-0.5 shrink-0 text-gold" /> {c.note}
                  </p>
                </div>
              </FadeUp>
            </div>

            {/* right: form */}
            <div className="lg:col-span-7">
              <FadeUp delay={0.1}>
                <EnquiryForm services={services} />
              </FadeUp>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
